import * as React from 'react'

function TravelIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={56} height={56} viewBox="0 0 40 40" {...props}>
      <rect data-name="Rectangle 2345" width={40} height={40} rx={20} fill="#ffefed" />
      <g data-name="Group 51525" fill="none" stroke="#263238" strokeWidth={1.2}>
        <path data-name="Path 13634" d="M3.235 14v-1.821" strokeLinecap="square" transform="translate(12 13)" />
        <path data-name="Path 13635" d="M13.341 14v-1.821" strokeLinecap="square" transform="translate(12 13)" />
        <path data-name="Path 13633" d="M15.02 11.819H3.291L1.064 8.894" transform="translate(12 13)" />
        <path
          data-name="Path 12911"
          d="M8 0c4.418 0 8 2.694 8 6.017H0C0 2.694 3.582 0 8 0z"
          strokeLinejoin="round"
          transform="translate(12 13)"
        />
        <path data-name="Path 12910" d="M11.873 5.863C11.873.9 7.998 0 7.998 0" transform="translate(12 13)" />
        <path data-name="Path 13632" d="M7.844 11.78V6.474" transform="translate(12 13)" />
        <path data-name="Path 13631" d="M4.128 5.863C4.128.9 8.003 0 8.003 0" transform="translate(12 13)" />
      </g>
    </svg>
  )
}

export default TravelIcon
